import React from 'react';
import { FlexRow } from '@make-software/cspr-design';
import { PaginationInfoText } from './pagination-info-text';
import { PaginationDropdown } from './pagination-dropdown';
import { Trans, useTranslation } from 'react-i18next';

export const RowsPerPage = ({
  value,
  items,
  onChange,
}: {
  value: number;
  items: number[];
  onChange: (perPage) => void;
}) => {
  const { t } = useTranslation();
  return (
    <FlexRow itemsSpacing={4} align={'center'}>
      <PaginationInfoText>
        <Trans t={t}>Show rows</Trans>
      </PaginationInfoText>
      <PaginationDropdown value={value} items={items} onChange={onChange} />
    </FlexRow>
  );
};
